// function adjustReadMore() {
//   if (window.innerWidth < 750) {
//     var showChar = 50;
//     var ellipsestext = "";
//      var moretext = "Read More";
//     var lesstext = "Read Less";
//     var lookBookDescriptions = document.querySelectorAll('.Press_Description');
//     lookBookDescriptions.forEach(function(lookBookDescription) {
//       var content = lookBookDescription.innerHTML;
//       if (content.length > showChar) {
//         var c = content.substr(0, showChar);
//         var h = content.substr(showChar, content.length - showChar);
//         var html = c + '<span class="moreellipses">' + ellipsestext + '<span class="readdots">...</span></span><span class="morecontent"><span style="display:none;">' + h + '</span><a href="#" class="morelink">' + moretext + '</a></span>';
//         lookBookDescription.innerHTML = html;
//       }
//     });
//     var moreLinks = document.querySelectorAll('.morelink');
//     moreLinks.forEach(function(moreLink) {
//       moreLink.addEventListener('click', function(event) {
//         event.preventDefault();
//         var isLess = this.classList.contains('less');
//         if (isLess) {
//           this.classList.remove('less');
//           this.innerHTML = moretext;
//         } else {
//           this.classList.add('less');
//           this.innerHTML = lesstext;
//         }
//         this.parentElement.previousElementSibling.style.display = isLess ? 'inline' : 'none';
//         this.previousElementSibling.style.display = isLess ? 'none' : 'inline';
//       });
//     });
//   } else {
//     // Show the inner span elements with class "morecontent" inside paragraphs with class "read_more_content"
//     document.querySelectorAll("p.read_more_content span.morecontent span").forEach(function(element) {
//       element.style.display = "inline"; // or "block" depending on the desired display style
//     });

//     // Hide the "morelink" anchor elements inside paragraphs with class "read_more_content"
//     document.querySelectorAll("p.read_more_content span.morecontent a.morelink").forEach(function(element) {
//       element.style.display = "none";
//     });
//   }
// }

// window.addEventListener('resize', function(event) {
//  var readmoreshow = false;
//    if (window.innerWidth < 750 && readmoreshow == false ) {
//       var readmoreshow = true;
//    }
// });
document.addEventListener("DOMContentLoaded", function() {
// adjustReadMore();
function showElements(elements) {
  elements.forEach(function(element) {
    element.style.display = "block";
    element.style.transition = "height 0.5s ease"; // Optional: add a transition effect
  });
}
var elementsToShow = Array.from(document.querySelectorAll(".PressListing_Wrap .OuterPress_listing .InnerPress_Listing")).slice(0, 6);
showElements(elementsToShow);
document.querySelector(".LoadMore_Text").addEventListener('click', function (e) {
  e.preventDefault();
  var hiddenElements = Array.from(document.querySelectorAll(".PressListing_Wrap .OuterPress_listing .InnerPress_Listing")).filter(function(element) {
    return element.style.display === "none" || element.style.display === "";
  });
  elementsToShow = hiddenElements.slice(0, 6);
  showElements(elementsToShow);
    if (hiddenElements.length <= 6) {
    document.querySelector(".LoadMore_Text").style.display = "none";
  }
});

});
